export const RIGHT_CARD_HEIGHT = 484;
export const BOTTOM_CARD_HEIGHT = 396;
